import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AppConfigService } from '../../services/app-config.service';
import { MyRouter } from '../../../common/services/router.service';
import { OpcoPolicyLinksService } from '../../services/opco-policy-links.service';
import { IntercomService } from '../../external-app-services/intercom/intercom.service';
import { Observable } from 'rxjs';
import { UsersnapService } from '../../external-app-services/usersnap/usersnap.service';

@Component({
    selector: 'app-nav-desktop',
    templateUrl: './nav-desktop.component.html',
    styleUrls: ['./nav-desktop.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NavDesktopComponent {
    @Input() isAuthorized: boolean;
    @Input() corporateClientName: string;
    @Input() allowedToOrder$: Observable<boolean>;
    @Input() isOciUser: boolean;

    @Output() logout = new EventEmitter<void>();

    headerImage = this.appConfigService.getAppConfig().opCoImage || 'mateco.svg';
    termsAndConditionsLink: string;
    privacyPolicyLink: string;
    cookiePolicyLink: string;

    constructor(private appConfigService: AppConfigService,
                private opCoPolicyLinksService: OpcoPolicyLinksService,
                private router: MyRouter,
                private intercomService: IntercomService,
                private usersnapService: UsersnapService) {
    }

    navigateTo(url: string[]) {
        this.router.navigateWithCorporateClient(url);
    }

    clickHeaderImage() {
        this.router.navigateWithCorporateClient(this.isAuthorized ? ['/orders'] : ['/login']);
    }

    getPolicyLinks() {
        this.termsAndConditionsLink = this.opCoPolicyLinksService.getTermsConditionLink();
        this.privacyPolicyLink = this.opCoPolicyLinksService.getPrivacyPolicyLink();
        this.cookiePolicyLink = this.opCoPolicyLinksService.getCookiePolicyLink();
    }

    getWelcomeGuidedTour() {
        this.intercomService.getWelcomeTour();
    }

    openUsersnap() {
        this.usersnapService.open();
    }

    openCookieSettings() {
        (window as any).openKlaroDialog();
    }
}
